export default __webpack_public_path__ + "locales/sl/InfoPanel.json?hash=04fd2cc708cdd06017422a1d8d4c46e3";